const getters = {
  benefits: state => state.benefits,
};

export default getters;
